import axios from "axios";
import AxiosInstance1 from "../../hooks/AxiosInstance/AxiosInstance1";

const GetInitiativeStageDetails = async (IdeaId) => {
  // const accessToken = sessionStorage.getItem("access_token");
  // const userdata = JSON.parse(sessionStorage.getItem("user"));
  // const employeeId = userdata?.employeeId;
  console.log("ccccccccccc");
  try {
    const url = `/api/InitiativeList/GetInitiativeStageDetails?IdeaID=${IdeaId}`;
    const response = await AxiosInstance1.get(url);
    // const response = await axios.get(
    //   `${window.runtimeConfig.REACT_APP_BASEURL_ACCESS_CONTROL1}/api/InitiativeList/GetInitiativeStageDetails?IdeaID=${IdeaId}`,
    //   {
    //     headers: {
    //       Authorization: `Bearer ${accessToken}`
    //     }
    //   }
    // );
    return response.data;
  } catch (error) {
    console.error("Error fetching Initiative Stages:", error);
    throw new Error("Failed to fetch Initiative Stages");
  }
};

export default GetInitiativeStageDetails;
